import { h, render } from "preact";
import CompareModalContent from "./compareModalContent";

class CompareModalV2 extends HTMLElement {
  constructor() {
    super();

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        render(<CompareModalContent handle={this.handle} />, this);
      }
    }, {});

    observer.observe(this);
  }

  get handle() {
    return this.getAttribute("handle");
  }
}

if (!customElements.get("compare-modal-v2")) {
  customElements.define("compare-modal-v2", CompareModalV2);
}
